<!-- eslint-disable -->
<template lang="pug">
    table.navigator-table(:key="componentKey")
        tr.navigator-table__row(v-for="(row, rowIndex) in navigatorTable")
            th.navigator-table__row-number
                | {{size - rowIndex}}
            td.navigator-table__cell(v-for="(num, numIndex) in row")
                .navigator-table__press-item(
                    :class="getCellClasses(num, rowIndex, numIndex)"
                    @click="handleClick(num, rowIndex, numIndex)"
                )
                    transition(:name="getTransitionName")
                        img(v-if="num === clevikPosition" :src="clevikImg")
                        img(v-if="num !== clevikPosition && isFirstPortal(num)" :src="getImage(portal1Img)")
                        img(v-if="num !== clevikPosition && isSecondPortal(num)" :src="getImage(portal2Img)")
                    img(v-if="isInterior(num)" :src="interiorSrc(num)")
        tr
            th
            td.navigator-table__row-letter(v-for="num in size")
                | {{ alphabet[num - 1] }}
</template>

<script>
    /*eslint-disable*/
  import clevikImg from "../../../../assets/images/WaitingTurtle.svg"
  const portal1Img = "portal_1.gif"
  const portal2Img = "portal_2.gif"
  const treeImg = "tree.png"
  const windmillImg = "windmill.png"
  const poolImg = "pool.png"

  export default {
      props: {
          navigatorTable: {
              type: Array,
              default: () => {
                  return [];
              }
          },
          navigatorTableCells: {
              type: Array,
              default: () => {
                  return [];
              }
          },
          portals: {
              type: Array,
              default: () => {
                  return [];
              }
          },
          interior: {
              type: Array,
              default: () => {
                  return [];
              }
          },
          step: String,
          size: Number,
          clevikPosition: Number,
          isCellsClickable:{
              type: Boolean,
              default: false
          },
          isBattle: {
              type: Boolean,
              default: false
          }
      },
      data() {
          return {
              clevikImg,
              portal1Img,
              portal2Img,
              treeImg,
              windmillImg,
              poolImg,
              componentKey: 0
          }
      },
      mounted () {
          window.addEventListener('resize', this.throttledForceRerender);
          this.calculateSizeForNavigatorTable();
      },
      watch: {
          componentKey () {
              this.$nextTick(() => this.calculateSizeForNavigatorTable());
          }
      },
      computed: {
          getTransitionName () {
              return "fade-in-" + this.step;
          },
          alphabet() {
              const cyrillicAlphabet = ['a', 'б', 'в', 'г', 'д', 'е', 'ж', 'з', 'и', 'к'];
              const latinAlphabet = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j'];
              const latinLanguages = ['en', 'fr'];

              return latinLanguages.includes(this.$i18n.locale) ? latinAlphabet : cyrillicAlphabet;
          },
      },
      methods: {
          getCellClasses(num, rowIndex, numIndex) {
            return {
              'navigator-table__press-item--disabled': this.isCellDisabled(num, rowIndex, numIndex),
              'navigator-table__press-item_green': this.isCellCorrect(num, rowIndex, numIndex),
              'navigator-table__press-item_red': this.isCellInCorrect(num, rowIndex, numIndex)
            }
          },
          getImage(name) {
              return require(`../../../../assets/images/games/navigator/${name}`)
          },
          handleClick (num, rowIndex, numIndex) {
              !this.isCellDisabled(num, rowIndex, numIndex) &&
              !this.navigatorTableCells[rowIndex][numIndex].classList.contains('navigator-table__press-item_red') &&
              !this.navigatorTableCells[rowIndex][numIndex].classList.contains('navigator-table__press-item_green') &&
              this.$emit('handleClick', num, rowIndex, numIndex);
          },
          throttledForceRerender() {
              setTimeout(() => this.componentKey++, 100);
          },
          calculateSizeForNavigatorTable () {
              const windowWidth = window.innerWidth;
              const windowHeight = window.innerHeight;
              let navigatorTable = document.querySelector('.navigator-table');
              let items = Array.from(document.querySelectorAll('.navigator-table__cell'));
              const isFirefox = typeof InstallTrigger !== 'undefined';
              const containerWidth = windowWidth < 1200
                  ? navigatorTable.clientWidth - 10
                  : navigatorTable.parentElement.clientWidth - 150;
              const maxTableWidth = Math.min(navigatorTable.clientWidth, containerWidth);
              let maxTableHeight = null;
              if (isFirefox) {
                  maxTableHeight = navigatorTable.parentElement.clientHeight - 20;
              } else {
                  maxTableHeight = this.size > 6
                      ? navigatorTable.clientHeight - 10
                      : Math.min(windowHeight - 250, navigatorTable.clientHeight);
              }
              let itemSizeScaleValue = 0.95;
              if (this.isBattle) {
                  itemSizeScaleValue = this.size > 6 ? 0.8 : 0.9;
              }
              let itemSize = Math.min(maxTableWidth / this.size, maxTableHeight / this.size) * itemSizeScaleValue;
              if (itemSize < 55) {
                 itemSize = 55;
              }
              navigatorTable.style['width'] = itemSize * this.size + 'px'
              navigatorTable.style['height'] = itemSize * this.size + 'px'
              if (isFirefox && windowWidth > 786) {
                   navigatorTable.style['width'] = itemSize * this.size - 100 + 'px'
                   navigatorTable.style['height'] = itemSize * this.size - 100 + 'px'
              }
              const navigatorRowLetters = Array.from(document.querySelectorAll('.navigator-table__row-letter'))
              const navigatorRowNumbers = Array.from(document.querySelectorAll('.navigator-table__row-number'))
              const currentTableWidth = navigatorTable.clientWidth - navigatorRowNumbers[0].clientWidth;
              items.forEach(item => {
                  item.style['height'] = currentTableWidth / this.size + 'px'
                  item.style['width'] = currentTableWidth / this.size + 'px'
              });
              navigatorRowLetters.forEach(item => {
                  item.style['height'] = navigatorTable.clientWidth / 10 + 'px'
              })
              navigatorRowNumbers.forEach(item => {
                  item.style['width'] = navigatorTable.clientWidth / 10 + 'px'
              })
              navigatorTable.style['width'] = windowWidth < 1200
                      ? navigatorTable.clientWidth + 50 + 'px'
                      : navigatorTable.clientWidth + 'px';
          },
          isFirstPortal (num) {
              return this.portals[0] && this.portals[0].includes(num);
          },
          isSecondPortal(num) {
              return this.portals[1] && this.portals[1].includes(num);
          },
          isInterior(num) {
              return !!this.interior.find(interiorObject => interiorObject.value === num);
          },
          interiorSrc (num) {
              switch (this.interior.find(interiorObject => interiorObject.value === num).element) {
                  case "tree":
                      return this.getImage(treeImg);
                  case "windmill":
                      return this.getImage(windmillImg);
                  case "pool":
                      return  this.getImage(poolImg);
              }
          },
          isCellDisabled (num, rowIndex, numIndex) {
              if (!this.navigatorTableCells.length) {
                  return !this.isCellsClickable || this.isInterior(num)
              } else {
                  return (!this.isCellsClickable || this.isInterior(num)) &&
                     !this.navigatorTableCells[rowIndex][numIndex].classList.contains('navigator-table__press-item_red') &&
                     !this.navigatorTableCells[rowIndex][numIndex].classList.contains('navigator-table__press-item_green')
              }
          },
          isCellCorrect(num, rowIndex, numIndex) {
            if (this.isCellDisabled(num, rowIndex, numIndex)) {
              return false;
            }
            return this.navigatorTableCells[rowIndex][numIndex].classList.contains('navigator-table__press-item_green');
          },
          isCellInCorrect(num, rowIndex, numIndex) {
            if (this.isCellDisabled(num, rowIndex, numIndex)) {
              return false;
            }
            return this.navigatorTableCells[rowIndex][numIndex].classList.contains('navigator-table__press-item_red');
          }
      },
      beforeDestroy () {
          window.removeEventListener('resize', this.throttledForceRerender);
      }
  }
</script>

<style scoped lang="scss">

    .fade-in-up-enter-active,
    .fade-in-down-enter-active,
    .fade-in-left-enter-active,
    .fade-in-right-enter-active,
    .fade-in-up-leave-active,
    .fade-in-down-leave-active,
    .fade-in-left-leave-active,
    .fade-in-right-leave-active {
        transition: all 1s;
    }

    .fade-in-up-enter {
        opacity: 0;
        transform: translate3d(0, 100%, 0);
    }

    .fade-in-down-enter {
        opacity: 0;
        transform: translate3d(0, -100%, 0);
    }

    .fade-in-left-enter {
        opacity: 0;
        transform: translate3d(200%, 0, 0);
    }

    .fade-in-right-enter  {
        opacity: 0;
        transform: translate3d(-200%, 0, 0);
    }

    .fade-in-up-leave-to,
    .fade-in-down-leave-to,
    .fade-in-left-leave-to,
    .fade-in-right-leave-to,
    .fade-in-up-leave,
    .fade-in-down-leave,
    .fade-in-left-leave,
    .fade-in-right-leave {
        opacity: 0;
    }

    .fade-in-up-enter-to,
    .fade-in-down-enter-to,
    .fade-in-left-enter-to,
    .fade-in-right-enter-to {
        opacity: 1;
        transform: translate3d(0, 0, 0);
    }

    .navigator-table {
        border-spacing: 0;
        width: 90%;
        height: 90%;
        table-layout: fixed;
        @include media($xlg) {
            width: 95%;
            height: 95%;
        }
    }

    .navigator-table__cell {
        text-align: center;
        vertical-align: middle;
        background: $hsl-color-gray-93;
    }

    .navigator-table__press-item {
        width: 90%;
        height: 90%;
        margin: auto;
        display: flex;
        cursor: pointer;
        user-select: none;
        align-items: center;
        border-radius: 12px;
        justify-content: center;
        background-color: $x-color-white;
        box-shadow: 0 0 2px $hsl-color-gray-74;
        position: relative;
        @include media($xlg) {
          &:hover {
              background-color: $hsl-color-green-58;
          }
        }
        img {
            position: absolute;
            height: 90%;
            width: 90%;
        }
    }

    .navigator-table__press-item_green {
        background-color: $hsl-color-green-58;
        &:hover {
            background-color: $hsl-color-green-58;
            cursor: auto;
        }
    }

    .navigator-table__press-item_red {
        background-color: $hsl-color-red-62;
        &:hover {
            background-color: $hsl-color-red-62;
            cursor: auto;
        }
    }

    .navigator-table__press-item--disabled {
        &:hover {
            background-color: $hsl-color-gray-93;
            cursor: auto;
        }
    }

    .navigator-table__row-number {
        width: 2rem;
    }

    .navigator-table__row-number, .navigator-table__row-letter {
        text-align: center;
        vertical-align: middle;
        font-weight: 600;
        font-size: 1.1rem;
        @include media($lg) {
            font-size: 1.3rem;
        }
    }
</style>
